<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">组名</span>
         <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
      </div>
      
	  <!-- <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
	  			class="reset-clear"
	  			:clearable="false"
	  			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始时间"
	        />
	  </div> 
	  
	  
	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
	      v-model="updateTime"
	  		  style="width: 180px;"
	      type="datetime"
	      :clearable="false"
	      unlink-panels
	      end-placeholder="结束时间"
	      value-format="yyyy-MM-dd HH:mm:ss"
	       />
	  </div> -->
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getBaiduFaceGetGroupListQueryFn()">
          搜索
        </el-button>
		
		<el-button type="primary" @click="editBtn(1)">
		  创建用户组
		</el-button>
		
		<el-button type="primary" @click="editBtn(9)">
		  人脸注册
		</el-button>
		
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="name" label="组名"></el-table-column>
	 <!-- <el-table-column align="center" prop="gender" label="性别"></el-table-column>
      <el-table-column align="center" prop="age" label="年龄"></el-table-column>
	  <el-table-column align="center"  label="图片">
	    <template slot-scope="{row}">
	      <el-image class="m-box-img" :src="row.pictureUrl" @click="editBtn(4,row)" lazy></el-image>
	    </template>
	  </el-table-column>
	  <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
	  <el-table-column align="center" prop="updateTime" label="更新时间"></el-table-column> -->
	  <el-table-column align="center" width="150" label="操作">
	    <template slot-scope="{row}">
	      <!-- <a class="glob-a"  @click="editBtn(2, row)">修改</a> -->
	      <a class="glob-a"  @click="editBtn(5, row)">删除</a> 
		  
		  <a class="glob-a"  @click="editBtn(6, row)">用户列表</a>
		  
		<!-- <a class="glob-a"  @click="editBtn(3, row)">人脸比对(1->N)</a> -->
	    </template>
	  </el-table-column>
	</el-table>  
	  
    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
	
	<!-- 新增编辑 -->
	  <el-dialog :title="editData.add === 1 ? '新增组名' : '编辑组名'" :visible.sync="editData.modal" width="600px">
	    <el-form label-width="140px">
	      <el-form-item label="组名：">
	        <el-input v-model.trim="editData.name" placeholder="请输入组名"/>
	      </el-form-item>
	    </el-form>
	
	    <div slot="footer">
	      <el-button @click="editData.modal = false">取 消</el-button>
	      <el-button type="primary" @click="addBtn">确 定</el-button>
	    </div>
	  </el-dialog>
	  
	  <!-- 人脸注册 待优化变更好用 -->
	    <el-dialog :title="faceRegistrationDialog.add === 1 ? '人脸注册' : '人脸更新'" :visible.sync="faceRegistrationDialog.modal" width="600px">
	      <el-form label-width="140px">
	        <el-form-item label="图片信息：">
	          <el-input v-model.trim="faceRegistrationDialog.image" placeholder="请输入图片信息"/>
	        </el-form-item>
	      </el-form>
		  
		  <el-form label-width="140px">
		    <el-form-item label="用户组id：">
		      <el-input v-model.trim="faceRegistrationDialog.groupId" placeholder="请输入用户组id"/>
		    </el-form-item>
		  </el-form>
		  
		  <el-form label-width="140px">
		    <el-form-item label="用户id：">
		      <el-input v-model.trim="faceRegistrationDialog.userId" placeholder="请输入用户id"/>
		    </el-form-item>
		  </el-form>
		  
		  <el-form label-width="140px">
		    <el-form-item label="用户资料：">
		      <el-input v-model.trim="faceRegistrationDialog.userInfo" placeholder="请输入用户资料"/>
		    </el-form-item>
		  </el-form>
		  
		  <el-form label-width="140px">
		    <el-form-item label="活体检测控制：">
		      <el-input v-model.trim="faceRegistrationDialog.livenessControl" placeholder="请输入活体检测控制"/>
		    </el-form-item>
		  </el-form>
		  
		  <el-form label-width="140px">
		    <el-form-item label="图片类型：">
		      <el-input v-model.trim="faceRegistrationDialog.imageType" placeholder="请输入图片类型"/>
		    </el-form-item>
		  </el-form>
		  
		  <el-form label-width="140px">
		    <el-form-item label="图片质量控制：">
		      <el-input v-model.trim="faceRegistrationDialog.qualityControl" placeholder="请输入图片质量控制"/>
		    </el-form-item>
		  </el-form>
		
		  <el-form label-width="140px" v-if="faceRegistrationDialog.add === 2">
			  <el-form-item label="操作方式：">
			  <el-input v-model.trim="faceRegistrationDialog.actionType" placeholder="请输入操作方式"/>
			</el-form-item>
		  </el-form>
	  
	      <div slot="footer">
	        <el-button @click="faceRegistrationDialog.modal = false">取 消</el-button>
	        <el-button type="primary" @click="addFaceAddBtn">确 定</el-button>
	      </div>
	    </el-dialog>
	  
	  <!-- 用户列表 -->
	  <el-dialog title="用户列表" :visible.sync="userListDialog.modal" width="90%">
	    <div class="minW1060-auto bg-fff mag10 pad10">
	      <el-row class="text-left">
	    		
	    <!--    <div class="dlblock-mb20 mr10">
	          <span class="pr5">用户名</span>
	          <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
	        </div>
	    	  
	    	  <div class="dlblock-mb20 mr10">
	    	    <span class="pr5">创建时间</span>
	    	    <el-date-picker
	    	        v-model="date"
	    	        style="width: 300px;"
	    	        type="daterange"
	    	        value-format="yyyy-MM-dd"
	    	        range-separator="至"
	    	        start-placeholder="开始日期"
	    	        end-placeholder="结束日期"/>
	    	  </div> -->
	    	  
	        <div class="dlblock-mb20 mr10">
	          <el-button type="primary" @click="pages.page = 1; baiduFaceGetUserListFn(groupId)">
	            查询
	          </el-button>
	        </div>
	        <!-- <div class="dlblock-mb20">
	          <el-button type="primary" @click="editBtn(1)">
	            新增
	          </el-button>
	        </div> -->
	      </el-row>
	    
	      <el-table class="my-table" :data="userListData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
	        <el-table-column align="center" prop="name" label="名称"></el-table-column>
	        <el-table-column align="center" prop="create_time" label="创建时间"></el-table-column>
	        <el-table-column align="center" width="150" label="操作">
	          <template slot-scope="{row}">
				<a class="glob-a"  @click="editBtn(8, row)">用户信息查询</a>
	  			<a class="glob-a"  @click="editBtn(7, row)">获取用户人脸列表</a>
				<a class="glob-a"  @click="editBtn(12, row)">复制用户</a>
				<a class="glob-a"  @click="editBtn(13, row)">删除用户</a>
	            <!-- <a class="glob-a"  @click="editBtn(2, row)">修改</a> -->
	    		<!-- <a class="glob-a"  @click="editBtn(5, row)">删除</a> -->
	          </template>
	        </el-table-column>
	      </el-table>
	    
	   <!--   <div class="my-pagination">
	        <el-pagination background layout="total, prev, pager, next" :total="subPages.total"
	                       :current-page="subPages.page" @current-change="subPageChange">
	        </el-pagination>
	      </div> -->
	    	
	    </div>	
	  </el-dialog>
	  
	  <!-- 用户列表下的人脸列表 -->
	  <el-dialog title="用户人脸列表" :visible.sync="userSubListDialog.modal" width="90%">
	    <div class="minW1060-auto bg-fff mag10 pad10">
	      <el-row class="text-left">
	    		
	      <!--  <div class="dlblock-mb20 mr10">
	          <span class="pr5">face_token</span>
	          <el-input v-model.trim="name" placeholder="请输入face_token" style="width: 150px;"/>
	        </div> -->
	    	  
	    	<!--  <div class="dlblock-mb20 mr10">
	    	    <span class="pr5">创建时间</span>
	    	    <el-date-picker
	    	        v-model="date"
	    	        style="width: 300px;"
	    	        type="daterange"
	    	        value-format="yyyy-MM-dd"
	    	        range-separator="至"
	    	        start-placeholder="开始日期"
	    	        end-placeholder="结束日期"/>
	    	  </div> -->
	    	  
	        <div class="dlblock-mb20 mr10">
	          <el-button type="primary" @click="pages.page = 1; baiduFaceGetAListOfUserFacesFn(groupId,userId)">
	            查询
	          </el-button>
	        </div>
	        <!-- <div class="dlblock-mb20">
	          <el-button type="primary" @click="editBtn(1)">
	            人脸注册
	          </el-button>
	        </div> -->
	      </el-row>
	    
	      <el-table class="my-table" :data="userSubListData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
	        <el-table-column align="center" prop="face_token" label="face_token"></el-table-column>
	        <el-table-column align="center" prop="ctime" label="创建时间"></el-table-column>
	        <el-table-column align="center" width="150" label="操作">
	          <template slot-scope="{row}">
	             <a class="glob-a"  @click="editBtn(10, row)">人脸更新</a> 
	    		<a class="glob-a"  @click="editBtn(11, row)">人脸删除</a> 
	          </template>
	        </el-table-column>
	      </el-table>
	    
	   <!--   <div class="my-pagination">
	        <el-pagination background layout="total, prev, pager, next" :total="subPages.total"
	                       :current-page="subPages.page" @current-change="subPageChange">
	        </el-pagination>
	      </div> -->
	    	
	    </div>	
	  </el-dialog>
	  
	  <!-- 用户列表下的用户信息 -->
	  <el-dialog title="用户信息" :visible.sync="userListInfoDialog.modal" width="90%">
	    <div class="minW1060-auto bg-fff mag10 pad10">
	      <el-row class="text-left">
	    		
	       <!-- <div class="dlblock-mb20 mr10">
	          <span class="pr5">用户信息</span>
	          <el-input v-model.trim="name" placeholder="请输入用户信息" style="width: 150px;"/>
	        </div> -->
	    	  
	    	<!--  <div class="dlblock-mb20 mr10">
	    	    <span class="pr5">创建时间</span>
	    	    <el-date-picker
	    	        v-model="date"
	    	        style="width: 300px;"
	    	        type="daterange"
	    	        value-format="yyyy-MM-dd"
	    	        range-separator="至"
	    	        start-placeholder="开始日期"
	    	        end-placeholder="结束日期"/>
	    	  </div> -->
	    	  
	        <div class="dlblock-mb20 mr10">
	          <el-button type="primary" @click="pages.page = 1; baiduUserInformationQueryFn(groupId,userId)">
	            查询
	          </el-button>
	        </div>
	     <!--   <div class="dlblock-mb20">
	          <el-button type="primary" @click="editBtn(1)">
	            新增
	          </el-button>
	        </div> -->
	      </el-row>
	    
	      <el-table class="my-table" :data="userListInfoData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
	        <el-table-column align="center" prop="user_info" label="用户信息"></el-table-column>
	        <el-table-column align="center" prop="group_id" label="组名称"></el-table-column>
	      <!--  <el-table-column align="center" width="150" label="操作">
	          <template slot-scope="{row}">
	             <a class="glob-a"  @click="editBtn(2, row)">修改</a>
	    		<a class="glob-a"  @click="editBtn(5, row)">删除</a> 
	          </template>
	        </el-table-column> -->
	      </el-table>
	    
	   <!--   <div class="my-pagination">
	        <el-pagination background layout="total, prev, pager, next" :total="subPages.total"
	                       :current-page="subPages.page" @current-change="subPageChange">
	        </el-pagination>
	      </div> -->
	    	
	    </div>	
	  </el-dialog>
	  
	  <!-- 图片放大 -->
	  <el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
	    <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
	  </el-dialog>
	  
  </div>
</template>

<script>
  import {
	//人脸库管理API 组列表查询
    getBaiduFaceGetGroupListQuery,
	//人脸库管理API 创建用户组
	baiduFaceCreateUserGroup,
	//人脸库管理API 删除用户组
	baiduFaceDeleteUserGroup,
	//人脸库管理API 获取用户列表
	baiduFaceGetUserList,
	//人脸库管理API 获取用户人脸列表
	baiduFaceGetAListOfUserFaces,
	//人脸库管理API 用户信息查询
	baiduUserInformationQuery,
	//人脸库管理API 人脸注册
	baiduFaceRegistration,
	//人脸库管理API 人脸删除
	baiduFaceDel,
	//人脸库管理API 删除用户
	baiduDeleteUsers,
	//人脸库管理API 复制用户
	baiduCopyUser,
	//人脸库管理API 人脸更新
	baiduFaceUpdate
	
	//虹软人脸库新增
	//hrFaceDatabaseSaveOrUpdate,
	//人脸比对 1 -> N
	//hrFaceComparison
  } from '@/api'

  import HrfaceDatabasePhoto from '@/components/HrFaceDatabasePhoto.vue'

  export default {
    name: 'UserList',	
	components: {HrfaceDatabasePhoto},
    data () {
      return {
        date: [],
        name: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
		//性别
		genderList:[{name:"请选择",value:""},{name:"男",value:"1"},{name:"女",value:"0"},{name:"未知",value:"-1"}],
		//二维码logo id
		hrFaceDatabaseId:'',
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
		createTime:'',
		updateTime:'',
		//百度人脸库
		editData: {
		  modal: false,
		  add: 1,
		  //编号
		  id:'',
		  //姓名
		  name: '',
		  //性别
		  gender:'',
		  //年龄
		  age:'',
		  //人脸图片
		  pictureUrl:'',
		},
		//人脸注册
		faceRegistrationDialog:{
			modal:false,
			add:1,
			image:'',
			groupId:'',
			userId:'',
			userInfo:'',
			livenessControl:'',
			imageType:'',
			qualityControl:''
		},
		//用户列表弹窗
		userListDialog:{
			modal: false
		},
		//用户列表数据
		userListData:{},
		//用户列表下的人脸列表弹窗
		userSubListDialog:{
			modal: false
		},
		//用户列表下的人脸列表数据
		userSubListData:{},
		//组id
		groupId:'',
		//用户id
		userId:'',
		//用户信息弹窗
		userListInfoDialog:{
			modal:false
		},
		//用户信息数据
		userListInfoData:{}
      }
    },
    created () {
      this.getBaiduFaceGetGroupListQueryFn()
    },
    methods: {
      getBaiduFaceGetGroupListQueryFn() {
        this.tableLoading = true
        getBaiduFaceGetGroupListQuery({
          pageNum: this.pages.page,
          name: this.name,
          createTime: this.createTime,
          updateTime: this.updateTime
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.total
		  console.info(this.tableData,"响应的数据")
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getBaiduFaceGetGroupListQueryFn()
      },
	  //二维码新增或修改
	  addBtn (t) {
	    if (this.editData.add == 1){
	  	  //添加
	  	  this.baiduFaceCreateUserGroupFn()
	    } else {
	  	  //修改
	  	  this.baiduFaceCreateUserGroupFn()
	    }
	  },
	  //创建用户组
	  baiduFaceCreateUserGroupFn(){
	    this.tableLoading = true
	    baiduFaceCreateUserGroup({
	  	  groupId:this.editData.name
	    }).then(res => {
	  	  this.editData.modal = false
	  	  this.$message.success(res.data)
	  	  this.getBaiduFaceGetGroupListQueryFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })
	  },
	  //删除用户组
	  baiduFaceDeleteUserGroupFn(name){
		  this.tableLoading = true
		  baiduFaceDeleteUserGroup({
		    groupId:name
		  }).then(res => {
		    this.editData.modal = false
		    this.$message.success(res.data)
		    this.getBaiduFaceGetGroupListQueryFn()
		  }).finally(() => {
		    this.tableLoading = false
		  })
	  },
	  //获取用户列表
	  baiduFaceGetUserListFn(name){
	  		  this.tableLoading = true
	  		  baiduFaceGetUserList({
	  		    groupId:name
	  		  }).then(res => {
				  this.userListData = res.data.list
	  		    //this.$message.success(res.data)
	  		    //this.getBaiduFaceGetGroupListQueryFn()
	  		  }).finally(() => {
	  		    this.tableLoading = false
	  		  })
	  },
	  //获取用户人脸列表
	  baiduFaceGetAListOfUserFacesFn(groupId,name){
		  this.tableLoading = true
		  baiduFaceGetAListOfUserFaces({
		    groupId:groupId,
			userId:name
		  }).then(res => {
		  	this.userSubListData = res.data.face_list
		    //this.$message.success(res.data)
		    //this.getBaiduFaceGetGroupListQueryFn()
		  }).finally(() => {
		    this.tableLoading = false
		  })
	  },
	  //用户信息查询
	  baiduUserInformationQueryFn(groupId,name){
		baiduUserInformationQuery({
		    groupId:groupId,
			userId:name
		  }).then(res => {
			this.userListInfoData = res.data.user_list
		    //this.$message.success(res.data)
		    //this.getBaiduFaceGetGroupListQueryFn()
		  }).finally(() => {
		    this.tableLoading = false
		  })  
	  },
	  //人脸注册
	  baiduFaceRegistrationFn(){
		  baiduFaceRegistration({
		    image:this.faceRegistrationDialog.image,
		    groupId:this.faceRegistrationDialog.groupId,
		  	userId:this.faceRegistrationDialog.userId,
		  	userInfo:this.faceRegistrationDialog.userInfo,
		  	livenessControl:this.faceRegistrationDialog.livenessControl,
		  	imageType:this.faceRegistrationDialog.imageType,
		  	qualityControl:this.faceRegistrationDialog.qualityControl
		      }).then(res => {
		  		if(res.code === 200){
		  			this.$message.success(res.data)
		  			this.faceRegistrationDialog = { modal:false }
		  		}else{
		  			this.$message.success(res.msg)
		  		}
		        //this.getBaiduFaceGetGroupListQueryFn()
		      }).finally(() => {
		        this.tableLoading = false
		      })  
		    console.info("人脸注册")
	  },
	  //人脸更新
	  baiduFaceUpdateFn(){
		  baiduFaceRegistration({
		    image:this.faceRegistrationDialog.image,
		    groupId:this.faceRegistrationDialog.groupId,
		  	userId:this.faceRegistrationDialog.userId,
		  	userInfo:this.faceRegistrationDialog.userInfo,
		  	livenessControl:this.faceRegistrationDialog.livenessControl,
		  	imageType:this.faceRegistrationDialog.imageType,
		  	qualityControl:this.faceRegistrationDialog.qualityControl,
			actionType:this.faceRegistrationDialog.actionType
		      }).then(res => {
		  		if(res.code === 200){
		  			this.$message.success(res.data)
		  			this.faceRegistrationDialog = { modal:false }
		  		}else{
		  			this.$message.success(res.msg)
		  		}
		        //this.getBaiduFaceGetGroupListQueryFn()
		      }).finally(() => {
		        this.tableLoading = false
		      })  
		    console.info("人脸更新")
	  },
	  //人脸注册 或 更新
	  addFaceAddBtn(){
		  //人脸注册弹窗
		  let add = this.faceRegistrationDialog.add 
		  if( add == 1 ){
			  this.baiduFaceRegistrationFn()
			  console.info("人脸注册")
		  }else{
			  this.baiduFaceUpdateFn()
			  console.info("人脸更新")
		  }
		},
		//人脸删除
		baiduFaceDelFn(groupId,userId,faceToken){
			baiduFaceDel({
			  	groupId:groupId,
				userId:userId,
				faceToken:faceToken
			    }).then(res => {
					if(res.code === 200){
						//刷新
						this.$message.success(res.data)
					}else{
						this.$message.success(res.msg)
					}
			      //this.getBaiduFaceGetGroupListQueryFn()
			    }).finally(() => {
			      this.tableLoading = false
			    })  
			  console.info("人脸删除")
		},
		//删除用户
		baiduDeleteUsersFn(groupId,userId){
			baiduDeleteUsers({
			  	groupId:groupId,
				userId:userId
			    }).then(res => {
					if(res.code === 200){
						//刷新
						this.$message.success(res.data)
					}else{
						this.$message.success(res.msg)
					}
			      //this.getBaiduFaceGetGroupListQueryFn()
			    }).finally(() => {
			      this.tableLoading = false
			    })  
			  console.info("删除用户")
		},
		//复制用户
		baiduCopyUserFn(userId,srcGroupId,dstGroupId){
			baiduCopyUser({
				userId:userId,
				srcGroupId:srcGroupId,
				dstGroupId:dstGroupId
			}).then(res => {
				if(res.code === 200){
					//刷新
					this.$message.success(res.data)
				}else{
					this.$message.success(res.msg)
				}
			      //this.getBaiduFaceGetGroupListQueryFn()
			}).finally(() => {
			      this.tableLoading = false
			})  
			  console.info("复制用户")
		},
	  editBtn(t,row) {
			//1新增弹窗
			if(t == 1){
				this.editData = {
				modal: true,
				add: 1,
				}
			}else if(t == 2){
				//修改
				this.editData = {
				  modal: true,
				  add: 2,
				  id:row.id,
				  name:row.name,
				  gender:row.gender,
				  age:row.age,
				  pictureUrl:row.pictureUrl
				} 
				this.hrFaceDatabaseId = row.id
			}else if( t == 3 ){
				//人脸比对 1 -> N
				this.tableLoading = true
				hrFaceComparison({
				  id:row.id,
				}).then(res => {
				  this.editData.modal = false
				  this.$message.success(res.data)
				  this.getBaiduFaceGetGroupListQueryFn()
				}).finally(() => {
				  this.tableLoading = false
				})	
			}else if( t == 4 ){
				//图片放大
				  this.imgPreData = {
				    modal: true,
					url:row.pictureUrl
				  }
			}else if( t == 5 ){
				this.$confirm(`确认要删除吗`, '提示', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				  }).then(() => {
					 let name =  row.name
					 //删除
					 this.baiduFaceDeleteUserGroupFn(name)
				});
				
			}else if( t == 6 ){
				//用户列表弹窗
				this.userListDialog = {
				modal: true
				}
				//用户列表
				let name =  row.name
				this.groupId = name
				this.baiduFaceGetUserListFn(name)
				console.info("用户列表")
			}else if( t == 7 ){
				//用户列表下的人脸列表弹窗
				this.userSubListDialog = {
					modal:true
				}
				//组名称
				let groupId = this.groupId
				//用户名称
				let name =  row.name
				this.userId = name
				//获取用户人脸列表
				this.baiduFaceGetAListOfUserFacesFn(groupId,name)
			}else if( t == 8 ){
				//弹出展示框显示
				this.userListInfoDialog = {
					modal:true
				}
				//组名称
				let groupId = this.groupId
				//用户名称
				let name =  row.name
				//用户信息查询
				this.baiduUserInformationQueryFn(groupId,name)
			}else if( t == 9 ){
				console.info("人脸注册")
				//人脸注册弹窗
				this.faceRegistrationDialog = { modal:true,add:1 }
			}else if( t == 10 ){
				//人脸注册弹窗
				this.faceRegistrationDialog = { modal:true,add:2 }
				console.info("人脸更新")
			}else if( t == 11 ){
				console.info("人脸删除")
				//组名称
				let groupId = this.groupId
				//用户名称
				let name =  this.userId
				//需要删除的人脸图片token
				let faceToken =  row.face_token
				this.$confirm(`确认要删除吗`, '提示', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				  }).then(() => {
					 this.baiduFaceDelFn(groupId,name,faceToken)
				});
			}else if( t == 12 ){
				console.info("复制用户")
				//TODO test 需要改为 弹窗选择 移动到那个组
				this.baiduCopyUserFn(row.name,this.groupId,"test")
			}else if( t == 13 ){
				console.info("删除用户")
				this.$confirm(`确认要删除吗`, '提示', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				  }).then(() => {
					  this.baiduDeleteUsersFn(this.groupId,row.name)
					  console.info("您点击了确认")
				});
			}
		}
    }
  }
</script>

<style scoped>

</style>
